import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { reduxKey, removeDeviationFromGroupSuccess } from './actionCreators';
const handler = handleActions({
    [removeDeviationFromGroupSuccess.toString()]: (state, action)=>{
        return _object_spread_props(_object_spread({}, state), {
            removedGroupIds: !state.removedGroupIds.includes(action.payload.groupId) ? [
                ...state.removedGroupIds,
                action.payload.groupId
            ] : state.removedGroupIds
        });
    }
}, {
    removedGroupIds: []
});
const reducers = {
    [reduxKey]: handler
};
export default reducers;
